import { AbstractControl, Validators } from '@angular/forms';
import { QarepaBaseFormsDirective } from '@qarepa/common';
import { PasswordValidator } from '@qaroni-core/validators/password.validator';

export class AccountResetPasswordForm extends QarepaBaseFormsDirective {
  private skeleton = {
    password: ['', [Validators.required, Validators.minLength(8)]],
    confirmPassword: ['', [Validators.required]],
  };

  protected form = this.fb.nonNullable.group(this.skeleton, {
    validators: PasswordValidator.matchPassword,
  });

  get password() {
    return this.form.get('password') as AbstractControl;
  }

  get confirmPassword() {
    return this.form.get('confirmPassword') as AbstractControl;
  }

  get dirtyValidForm() {
    return this.form.dirty && this.form.valid;
  }

  get validatedForm() {
    return this.dirtyValidForm && !this.submitting;
  }
}
